import { CampagneFichierDto, CampagneFichierType } from '@common/services';
import { queryDownloadFile } from '../common/pageable/query-download-file';
import { servicesApi } from '../services';

const CAMPAGNES_FICHIERS_URL_PREFIX = (id: number) => `campagnes/${id}/fichiers`;

const campagneFichierApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    downloadCampagneFichier: build.mutation<void, DownloadCampagneFichierMutationArgs, any>({
      queryFn: ({ id, fichierType }, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `${CAMPAGNES_FICHIERS_URL_PREFIX(id)}/${fichierType}/resource`,
      }),
    }),

    uploadCampagneFichier: build.mutation<CampagneFichierDto, UploadCampagneFichierMutationArgs, any>({
      query:({ id, fichierType, body }) => ({
        method: 'POST',
        url: `${CAMPAGNES_FICHIERS_URL_PREFIX(id)}/${fichierType}`,
        body,
      }),
      invalidatesTags: ['CampagneFichiers'],
    }),

    downloadDeclarationTemplate: build.mutation<void, void, any>({
      queryFn: (_arg, _api, _extraOptions, baseQuery) => queryDownloadFile({
        baseQuery,
        url: `campagnes/declaration/template`,
      }),
    }),

    replaceCampagneFichier: build.mutation<void, ReplaceCampagneFichierMutationArgs, any>({
      query: ({ id, fichierType, file }) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: `${CAMPAGNES_FICHIERS_URL_PREFIX(id)}/${fichierType}/resource`,
          method: 'PUT',
          body: formData,
        };
      },
      invalidatesTags: ['CampagneFichiers'],
    }),
  }),
});

interface DownloadCampagneFichierMutationArgs {
  id: number;
  fichierType: CampagneFichierType;
}

interface UploadCampagneFichierMutationArgs {
  id: number;
  fichierType: CampagneFichierType;
  body: FormData;
}

interface ReplaceCampagneFichierMutationArgs {
  id: number;
  fichierType: CampagneFichierType;
  file: File;
}

export const {
  useDownloadCampagneFichierMutation,
  useDownloadDeclarationTemplateMutation,
  useReplaceCampagneFichierMutation,
} = campagneFichierApi;